export const AGE_RESTRICTED_PRIMARY_COLOR = '#7C3AED';
export const AGE_RESTRICTED_DARK_COLOR = '#4C1D95';
export const AGE_RESTRICTED_BANNER_COLOR = '#EEE7FF';
